class SearchDrawer extends HTMLElement {
  constructor() {
    super();
    
    this.overlay = this.querySelector('.search-drawer__overlay');
    this.closeButton = this.querySelector('.search-drawer__close');
    this.searchInput = this.querySelector('.search-drawer__input');
    
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.overlay?.addEventListener('click', this.close.bind(this));
    this.closeButton?.addEventListener('click', this.close.bind(this));
    
    this.setHeaderSearchIconAccessibility();
  }

  setHeaderSearchIconAccessibility() {
    const searchButtons = document.querySelectorAll('[data-search-drawer-trigger]');
    
    searchButtons.forEach(button => {
      button.setAttribute('role', 'button');
      button.setAttribute('aria-haspopup', 'dialog');
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(button);
      });
      button.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE' || event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
          this.open(button);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    
    setTimeout(() => {
      this.classList.add('active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const focusElement = this.searchInput || this.querySelector('input[type="search"]');
        if (focusElement) {
          focusElement.focus();
        }
        trapFocus(this.querySelector('.search-drawer__inner'), focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    
    // 如果使用 Lenis 平滑滚动
    if (window.lenis) {
      window.lenis.stop();
    }
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    
    // 恢复 Lenis 平滑滚动
    if (window.lenis) {
      window.lenis.start();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('search-drawer', SearchDrawer);
